// extracted by mini-css-extract-plugin
export default {"tabsHeader":"tabs-module__tabsHeader__yW2rc","tabsonly":"tabs-module__tabsonly__Kuskz","invertOrder":"tabs-module__invertOrder__V7XET","headerComp":"tabs-module__headerComp__UYRty"};